// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1igDP","col":"styles_col__21Zay","actions":"styles_actions__34aXk","conflict":"styles_conflict__27LPh"};